export type CgcTokenClaim = {
  version: '0.1.0';
  name: 'cgc_token_claim';
  instructions: [
    {
      name: 'newDistributor';
      accounts: [
        {
          name: 'distributorAuthority';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'distributorAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'rent';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'handle';
          type: 'string';
        },
        {
          name: 'bump';
          type: 'u8';
        },
        {
          name: 'unlockInterval';
          type: 'u64';
        },
      ];
    },
    {
      name: 'setWhitelist';
      accounts: [
        {
          name: 'distributorAuthority';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'distributorAccount';
          isMut: true;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'root';
          type: {
            array: ['u8', 32];
          };
        },
      ];
    },
    {
      name: 'toggleFreezeDistributor';
      accounts: [
        {
          name: 'distributorAuthority';
          isMut: false;
          isSigner: true;
        },
        {
          name: 'distributorAccount';
          isMut: true;
          isSigner: false;
        },
      ];
      args: [];
    },
    {
      name: 'initUserClaimStatus';
      accounts: [
        {
          name: 'userAuthority';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'userClaimStatus';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'distributorAccount';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'systemProgram';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'rent';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'bump';
          type: 'u8';
        },
      ];
    },
    {
      name: 'claim';
      accounts: [
        {
          name: 'userAuthority';
          isMut: true;
          isSigner: true;
        },
        {
          name: 'distributorAccount';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'tokenMint';
          isMut: false;
          isSigner: false;
        },
        {
          name: 'userClaimStatus';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'from';
          isMut: true;
          isSigner: false;
        },
        {
          name: 'to';
          isMut: true;
          isSigner: false;
          docs: ['Account to send the claimed tokens to.'];
        },
        {
          name: 'tokenProgram';
          isMut: false;
          isSigner: false;
        },
      ];
      args: [
        {
          name: 'index';
          type: 'u64';
        },
        {
          name: 'unlockedAmount';
          type: 'u64';
        },
        {
          name: 'vestingAmount';
          type: 'u64';
        },
        {
          name: 'vestingStart';
          type: 'u64';
        },
        {
          name: 'vestingPeriod';
          type: 'u64';
        },
        {
          name: 'proof';
          type: {
            vec: {
              array: ['u8', 32];
            };
          };
        },
      ];
    },
  ];
  accounts: [
    {
      name: 'distributorAccount';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'handle';
            type: {
              array: ['u8', 10];
            };
          },
          {
            name: 'distributorAuthority';
            type: 'publicKey';
          },
          {
            name: 'tokenMint';
            type: 'publicKey';
          },
          {
            name: 'freezeProgram';
            type: 'bool';
          },
          {
            name: 'bump';
            type: 'u8';
          },
          {
            name: 'unlockInterval';
            type: 'u64';
          },
          {
            name: 'merkleRoot';
            type: {
              array: ['u8', 32];
            };
          },
        ];
      };
    },
    {
      name: 'userClaimStatusAccount';
      type: {
        kind: 'struct';
        fields: [
          {
            name: 'claimedAmount';
            type: 'u64';
          },
          {
            name: 'bump';
            type: 'u8';
          },
        ];
      };
    },
  ];
  errors: [
    {
      code: 6000;
      name: 'PermissionError';
      msg: 'Invalid request';
    },
    {
      code: 6001;
      name: 'InvalidProof';
      msg: 'Invalid proof';
    },
    {
      code: 6002;
      name: 'InvalidAmount';
      msg: 'Invalid amount';
    },
    {
      code: 6003;
      name: 'DistributorUnavailable';
      msg: 'Distributor unavailable';
    },
  ];
};

export const IDL: CgcTokenClaim = {
  version: '0.1.0',
  name: 'cgc_token_claim',
  instructions: [
    {
      name: 'newDistributor',
      accounts: [
        {
          name: 'distributorAuthority',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'distributorAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'rent',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'handle',
          type: 'string',
        },
        {
          name: 'bump',
          type: 'u8',
        },
        {
          name: 'unlockInterval',
          type: 'u64',
        },
      ],
    },
    {
      name: 'setWhitelist',
      accounts: [
        {
          name: 'distributorAuthority',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'distributorAccount',
          isMut: true,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'root',
          type: {
            array: ['u8', 32],
          },
        },
      ],
    },
    {
      name: 'toggleFreezeDistributor',
      accounts: [
        {
          name: 'distributorAuthority',
          isMut: false,
          isSigner: true,
        },
        {
          name: 'distributorAccount',
          isMut: true,
          isSigner: false,
        },
      ],
      args: [],
    },
    {
      name: 'initUserClaimStatus',
      accounts: [
        {
          name: 'userAuthority',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'userClaimStatus',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'distributorAccount',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'systemProgram',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'rent',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'bump',
          type: 'u8',
        },
      ],
    },
    {
      name: 'claim',
      accounts: [
        {
          name: 'userAuthority',
          isMut: true,
          isSigner: true,
        },
        {
          name: 'distributorAccount',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'tokenMint',
          isMut: false,
          isSigner: false,
        },
        {
          name: 'userClaimStatus',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'from',
          isMut: true,
          isSigner: false,
        },
        {
          name: 'to',
          isMut: true,
          isSigner: false,
          docs: ['Account to send the claimed tokens to.'],
        },
        {
          name: 'tokenProgram',
          isMut: false,
          isSigner: false,
        },
      ],
      args: [
        {
          name: 'index',
          type: 'u64',
        },
        {
          name: 'unlockedAmount',
          type: 'u64',
        },
        {
          name: 'vestingAmount',
          type: 'u64',
        },
        {
          name: 'vestingStart',
          type: 'u64',
        },
        {
          name: 'vestingPeriod',
          type: 'u64',
        },
        {
          name: 'proof',
          type: {
            vec: {
              array: ['u8', 32],
            },
          },
        },
      ],
    },
  ],
  accounts: [
    {
      name: 'distributorAccount',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'handle',
            type: {
              array: ['u8', 10],
            },
          },
          {
            name: 'distributorAuthority',
            type: 'publicKey',
          },
          {
            name: 'tokenMint',
            type: 'publicKey',
          },
          {
            name: 'freezeProgram',
            type: 'bool',
          },
          {
            name: 'bump',
            type: 'u8',
          },
          {
            name: 'unlockInterval',
            type: 'u64',
          },
          {
            name: 'merkleRoot',
            type: {
              array: ['u8', 32],
            },
          },
        ],
      },
    },
    {
      name: 'userClaimStatusAccount',
      type: {
        kind: 'struct',
        fields: [
          {
            name: 'claimedAmount',
            type: 'u64',
          },
          {
            name: 'bump',
            type: 'u8',
          },
        ],
      },
    },
  ],
  errors: [
    {
      code: 6000,
      name: 'PermissionError',
      msg: 'Invalid request',
    },
    {
      code: 6001,
      name: 'InvalidProof',
      msg: 'Invalid proof',
    },
    {
      code: 6002,
      name: 'InvalidAmount',
      msg: 'Invalid amount',
    },
    {
      code: 6003,
      name: 'DistributorUnavailable',
      msg: 'Distributor unavailable',
    },
  ],
};
